import { graphql } from '@/gql';
import { MasterCallSummaryQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const masterCallSummary = async ({ operatorId, startDate, endDate }: MasterCallSummaryQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      operatorId,
      startDate,
      endDate,
    },
    query: graphql(`
      query MasterCallSummary($operatorId: String!, $startDate: String!, $endDate: String!) {
        masterCallSummary(operatorId: $operatorId, startDate: $startDate, endDate: $endDate) {
          overallAssessment
          callCount
          wins {
            callLogId
            summary
          }
          misses {
            callLogId
            summary
          }
        }
      }
    `),
  });

  return response.data?.masterCallSummary ?? null;
};
